"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sectionRange = exports.sectionTitle = exports.sidebarSection = exports.DatePicker = exports._internal = exports.languageToDateFormat = void 0;
var R = __importStar(require("ramda"));
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = require("../Button");
var ErrorBoundary_1 = require("../ErrorBoundary");
var luxon_1 = require("luxon");
var react_date_range_1 = require("react-date-range");
require("react-date-range/dist/styles.css"); // main style file
require("react-date-range/dist/theme/default.css"); // theme css file
var locale_1 = require("react-date-range/dist/locale");
require("./DatePicker.css");
function SidebarRangeSection(_a) {
    var config = _a.config, selectedId = _a.selectedId, onRangeSelect = _a.onRangeSelect;
    var title = config.title, ranges = config.ranges;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("h4", { className: "date-range-title" }, title),
        react_1["default"].createElement("ul", null, ranges.map(function (_a) {
            var id = _a.id, label = _a.label;
            return (react_1["default"].createElement("li", { key: id },
                react_1["default"].createElement("span", { className: id, onClick: function () { return onRangeSelect(id); } },
                    react_1["default"].createElement("input", { type: "radio", onChange: function () { return onRangeSelect(id); }, checked: selectedId === id }),
                    label)));
        }))));
}
var rangeConfigShape = prop_types_1["default"].shape({
    title: prop_types_1["default"].string,
    ranges: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
        id: prop_types_1["default"].string,
        label: prop_types_1["default"].string
    }))
});
SidebarRangeSection.propTypes = {
    config: rangeConfigShape,
    onRangeSelect: prop_types_1["default"].func,
    selectedId: prop_types_1["default"].string
};
var applyRange = R.cond([
    [R.is(Function), function (spec) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return spec.apply(void 0, args);
        }],
    [R.is(Array), R.identity],
    [R.T, function (_, selectedRanges, idx) { return selectedRanges[idx]; }],
]);
var rangeSpecFor = function (_a, selected) {
    var ranges = _a.ranges;
    return R.prop('range', R.find(R.propEq('id', selected), ranges));
};
var rangeSpecsFor = R.zipWith(rangeSpecFor);
var applyRangeSpecs = function (rangeSpecs, selectedRanges, namedRangeIds) {
    return R.addIndex(R.reduce)(function (newSelectedRanges, rangeSpec, idx) {
        return R.update(idx, applyRange(rangeSpec, newSelectedRanges, idx, namedRangeIds), newSelectedRanges);
    }, selectedRanges, rangeSpecs);
};
var doSidebarRangeSelect = R.curry(function (rangeConfigs, selectedNamedRanges, updateNamedCalendarRanges, updateCalendarRanges, selectedRanges, index, selection) {
    var newSelectedNamedRanges = R.update(index, selection, selectedNamedRanges);
    var newSelectedRanges = applyRangeSpecs(rangeSpecsFor(rangeConfigs, newSelectedNamedRanges), selectedRanges, newSelectedNamedRanges);
    updateCalendarRanges(newSelectedRanges);
    updateNamedCalendarRanges(newSelectedNamedRanges);
});
var DatePickerSidebar = function (_a) {
    var rangeConfig = _a.rangeConfig, selectedSidebarRanges = _a.selectedSidebarRanges, onNamedRangeSelect = _a.onNamedRangeSelect, restProps = __rest(_a, ["rangeConfig", "selectedSidebarRanges", "onNamedRangeSelect"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: 'vs-date-picker-sidebar' }), R.addIndex(R.zipWith)(function (config, selected, index) { return (react_1["default"].createElement(SidebarRangeSection, { key: config.title, config: config, selectedId: selected, onRangeSelect: onNamedRangeSelect(index) })); }, rangeConfig, selectedSidebarRanges)));
};
DatePickerSidebar.propTypes = {
    onNamedRangeSelect: prop_types_1["default"].func,
    rangeConfig: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
        title: prop_types_1["default"].string,
        ranges: prop_types_1["default"].array
    })),
    selectedSidebarRanges: prop_types_1["default"].arrayOf(prop_types_1["default"].string),
    comparisonRanges: prop_types_1["default"].arrayOf(prop_types_1["default"].array)
};
var languageToLocale = {
    cs: locale_1.cs,
    de: locale_1.de,
    en: locale_1.enUS,
    es: locale_1.es,
    fr: locale_1.fr,
    pl: locale_1.pl,
    zh: locale_1.zhCN,
    ja: locale_1.ja,
    pt: locale_1.pt
};
exports.languageToDateFormat = {
    cs: 'D. MMMM YYYY',
    de: 'D. MMMM YYYY',
    en: 'MMMM D, YYYY',
    es: 'D [de] MMMM [de] YYYY',
    fr: 'D MMMM YYYY',
    pl: 'D MMMM YYYY',
    zh: 'YYYY年MMMMD日',
    pt: 'D [de] MMMM [de] YYYY',
    ja: 'YYYY年M月D日'
};
var internalDateFormat = 'yyyy-MM-dd';
function fromInternalDateFormat(date) {
    return luxon_1.DateTime.fromFormat(date, internalDateFormat).toLocal();
}
exports._internal = { internalDateFormat: internalDateFormat, fromInternalDateFormat: fromInternalDateFormat };
var rangeToCalendarInput = function (range, intervalColor) {
    return {
        startDate: range[0] && fromInternalDateFormat(range[0]).toJSDate(),
        endDate: range[1] && fromInternalDateFormat(range[1]).toJSDate(),
        range1: range,
        color: intervalColor
    };
};
function updateSelectedRanges(idx, newRange, selectedRanges) {
    return R.update(idx, R.map(function (v) { return v && luxon_1.DateTime.fromJSDate(v).toFormat('yyyy-MM-dd'); }, newRange), selectedRanges);
}
var adaptToReactDateRange = function (intervalColors, intervals, namedIntervals) {
    var result = R.zipWith(rangeToCalendarInput, intervals, intervalColors);
    result = R.zipWith(function (range, interval) { return (interval === 'none' ? null : range); }, result, namedIntervals);
    return R.filter(R.identity, result);
};
var DatePicker = function (_a) {
    var updateCalendarRanges = _a.updateCalendarRanges, updateNamedCalendarRanges = _a.updateNamedCalendarRanges, onApply = _a.onApply, _b = _a.onCancel, onCancel = _b === void 0 ? function () { } : _b, _c = _a.selectableRange, minDate = _c[0], maxDate = _c[1], selectedRanges = _a.selectedRanges, selectedNamedRanges = _a.selectedNamedRanges, sidebarConfig = _a.sidebarConfig, _d = _a.cancelButtonText, cancelButtonText = _d === void 0 ? 'Cancel' : _d, _e = _a.applyButtonText, applyButtonText = _e === void 0 ? 'Apply' : _e, _f = _a.locale, locale = _f === void 0 ? 'en' : _f, _g = _a.dateFormat, dateFormat = _g === void 0 ? exports.languageToDateFormat[locale] : _g, _h = _a.intervalColors, intervalColors = _h === void 0 ? ['#05afec', '#0061ac'] : _h, className = _a.className, restProps = __rest(_a, ["updateCalendarRanges", "updateNamedCalendarRanges", "onApply", "onCancel", "selectableRange", "selectedRanges", "selectedNamedRanges", "sidebarConfig", "cancelButtonText", "applyButtonText", "locale", "dateFormat", "intervalColors", "className"]);
    var rangeSelectHandler = doSidebarRangeSelect(sidebarConfig, selectedNamedRanges, updateNamedCalendarRanges, updateCalendarRanges);
    var calendarRangeInput = adaptToReactDateRange(intervalColors, selectedRanges, selectedNamedRanges);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: (0, classnames_1["default"])(className, 'vs-date-picker', {
            'vs-date-picker-side-by-side': R.length(calendarRangeInput) === 2
        }) }),
        react_1["default"].createElement("div", { className: "vs-date-picker-calendars" },
            react_1["default"].createElement(DatePickerSidebar, { rangeConfig: sidebarConfig, onNamedRangeSelect: rangeSelectHandler(selectedRanges), selectedSidebarRanges: selectedNamedRanges, selectedRanges: selectedRanges, onCalendarRangeUpdate: updateCalendarRanges }),
            react_1["default"].createElement("div", { className: "vs-date-pickers" }, R.addIndex(R.zipWith)(function (range, className, idx) { return (react_1["default"].createElement(react_date_range_1.DateRange, { key: className, className: className, onChange: function (_a) {
                    var range = _a.range1;
                    rangeSelectHandler(updateSelectedRanges(idx, R.props(['startDate', 'endDate'], range), selectedRanges), idx, 'custom');
                }, moveRangeOnFirstSelection: false, ranges: [range], minDate: fromInternalDateFormat(minDate).toJSDate(), maxDate: fromInternalDateFormat(maxDate).toJSDate(), direction: "vertical", scroll: { enabled: false }, locale: languageToLocale[locale], dateDisplayFormat: dateFormat })); }, calendarRangeInput, ['vs-calendar', 'vs-comparison-calendar vs-calendar']))),
        react_1["default"].createElement("div", { className: "vs-button-bar" },
            react_1["default"].createElement(Button_1.Button, { type: "text", onClick: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    onCancel.apply(void 0, args);
                }, className: "vs-cancel-button" }, cancelButtonText),
            react_1["default"].createElement(Button_1.Button, { type: "solid-primary", onClick: function (_) {
                    return onApply(R.map(R.prop('range1'), calendarRangeInput), selectedNamedRanges);
                }, className: "vs-apply-button" }, applyButtonText))));
};
exports.DatePicker = DatePicker;
exports.DatePicker.propTypes = {
    selectedRanges: prop_types_1["default"].array,
    selectedNamedRanges: prop_types_1["default"].arrayOf(prop_types_1["default"].string),
    sidebarConfig: prop_types_1["default"].arrayOf(rangeConfigShape),
    selectableRange: prop_types_1["default"].array,
    updateCalendarRanges: prop_types_1["default"].func.isRequired,
    updateNamedCalendarRanges: prop_types_1["default"].func.isRequired,
    onApply: prop_types_1["default"].func.isRequired,
    cancelButtonText: prop_types_1["default"].node,
    applyButtonText: prop_types_1["default"].node
};
exports["default"] = (0, ErrorBoundary_1.withErrorBoundary)(exports.DatePicker);
/*
 * Usage: sidebarSection(
 *     sectionRange('id', 'Label', ["2018-01-01", "2018-02-02"]),
 *     sectionTitle('Title'),
 * )
 */
var sidebarSection = function (title) {
    var ranges = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        ranges[_i - 1] = arguments[_i];
    }
    return R.pipe.apply(R, __spreadArray([title], ranges, false))({});
};
exports.sidebarSection = sidebarSection;
exports.sectionTitle = R.assoc('title');
var sectionRange = function (id, label, range) { return function (section) {
    return R.over(R.lensProp('ranges'), R.append({ id: id, label: label, range: range }), section);
}; };
exports.sectionRange = sectionRange;
